module.exports = __webpack_public_path__ + "img/logo_col.b181ac13.png";